import { State } from '@/store/state'
import { CompetitionResult, Ranking, RankingUi } from '@/model/CompetitionResult'
import GameState from '@/model/GameState'
import { ERROR_CODES } from '@/model/ErrorCodes'
import { Commit } from 'vuex'

export interface ResultState {
  current: CompetitionResult
}

const state: ResultState = {
  current: {
    zoneId: '',
    tournamentId: '',
    gametype: '',
    state: GameState.PENDING,
    nextGame: false,
    ranking: [],
    gameTechs: [],
  },
}

export const mutations = {
  storeCurrentResult(state: ResultState, result: CompetitionResult) {
    state.current = result
  },
}

export const actions = {
  fetchCompetitionResultById({ commit }: { commit: Commit }, competitionId: string) {
    return new Promise((res: (value?: unknown) => void, rej: (reason?: unknown) => void) => {
      fetch(`${process.env.VUE_APP_REST_URL}results/${competitionId}`, {
        credentials: 'same-origin',
        cache: 'no-cache',
      })
        .then((res) => {
          if (res.status >= 400) {
            commit('error', { id: 'fetchCompetitionResultById', responseStatus: res.status }, { root: true })
            throw { errorCode: res.status === 401 ? ERROR_CODES.UNAUTHORIZED : ERROR_CODES.UNKNOWN }
          }
          return res.json()
        })
        .then((data: CompetitionResult) => {
          commit('storeCurrentResult', data)
          // TODO: Store something in rootState as well for use in connection with "Replay" button which redirects to the Matching View?
          res()
        })
        .catch((err: Error) => {
          rej(err)
        })
    })
  },
}

export const getters = {
  ownRanking(state: ResultState, getters: any, rootState: State, rootGetters: any) {
    return state.current.ranking.filter((ranking: Ranking) => ranking.playerId === rootGetters.userId)[0] || {}
  },
  rankingTable(state: ResultState, getters: any, rootState: State, rootGetters: any): Array<RankingUi> {
    return state.current.ranking.map((item: Ranking) => ({
      ...item,
      isOwnPlayer: item.playerId === rootGetters.userId,
    }))
  },
  zoneId(state: ResultState, getters: any): string {
    return state.current.zoneId
  },
  tournamentId(state: ResultState, getters: any): string {
    return state.current.tournamentId
  },
  tournamentSupportedGameTechs(state: ResultState, getters: any): Array<string> {
    return state.current.gameTechs
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
